import Vue from 'vue'

export const overwriteFirmware = ({state, commit}, {file}) => {
    const data = new FormData();
    data.set("file", file)

    return Vue.prototype.$rest.post("/firmware", data, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

export const fetchFirmwareHistory = ({ commit, getters }) => {
    return Vue.prototype.$rest.get("/firmware").then(function (content) {
        commit("setFirmwareHistory", content.data)
    })
};



// WEBPACK FOOTER //
// ./src/store/actions/firmware.js